// export const skillsData = [
//   // Frontend Technologies
//   "HTML",
//   "CSS 3",
//   "JavaScript",
//   "TypeScript",
//   "React.js",
//   "Next.js",
//   "Tailwind CSS",
//   "Material-UI",
//   "Shadcn UI",
//   "Bootstrap",
  
//   // State Management
//   "Redux Toolkit",
//   "TanStack Query",
  
//   // Backend Technologies
//   "Node.js",
//   "Express.js",
//   "Nest.js",
//   "RESTful APIs",
//   "Socket.io",
  
//   // Databases
//   "MongoDB",
//   "PostgreSQL",
//   "Firebase",
//   "Supabase",
  
//   // Web3 & Blockchain
//   "Web3",
//   "Wagmi",
  
//   // CMS
//   "Sanity.io",
  
//   // DevOps & Deployment
//   "Git",
//   "GitHub",
//   "Docker",
//   "AWS (EC2)",
//   "DigitalOcean",
//   "Vercel",
//   "Netlify",
//   "Heroku",
  
//   // Payment & APIs
//   "Stripe",
//   "OAuth",
//   "Postman",
  
//   // Architecture & Practices
//   "Microservices",
//   "Performance Optimization",
// ];

export const skillsData = [
  "HTML",
  "CSS 3",
  "Bootstrap",
  "Tailwind CSS",
  "MaterialUI",
  "Javascript",
  "TypeScript",
  "React Js",
  "Next Js",
  "Node Js",
  "Express Js",
  "MongoDB",
  "Firebase",
  "PostgreSQL",
  "Github",
  "Git",
  "Vercel",
  "Netlify"
];

